import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../redux/actions/index";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

import axios from "../../util/axios-reportonce";
import ViewEditComment from "./ViewEditComment";
import authHeader from "../../services/auth-header";
import serverSelect from "../../serverSelect";

export default function ViewEditCommentsBlock(props) {
    const loading = useSelector((state) => state.listing.loading);
    const listing = useSelector((state) => state.listing.details);
    const listingId = useSelector((state) => state.listing.id);
    const user = useSelector((state) => state.user);
    const server = serverSelect();
    const request_headers = authHeader(user);
    const dispatch = useDispatch();
    const [deleteDialogVisible, setDeleteDialogVisible] = useState(false);
    const [deleteDialogId, setDeleteDialogId] = useState(null);
    const [deleteLoading, setDeleteLoading] = useState(false);

    const submitComment = (id, text) => {
        if (text.length >= 20) {
            axios
                .post(
                    `${server}/api/listings/comments/${listingId}`,
                    {
                        email: user.userData.username,
                        comment: text,
                        id: id,
                    },
                    authHeader(user)
                )
                .then(function (response) {
                    dispatch(actions.loadSpecificListing(listingId));
                    dispatch(
                        actions.showSnackbar(
                            "Comment successfully edited",
                            "success"
                        )
                    );
                })
                .catch(function (error) {
                    dispatch(
                        actions.showSnackbar("Error editing comment", "error")
                    );
                })
                .then(function () {
                    // always executed
                });
        }
    };

    const handleDeleteDialogOpen = (id) => {
        setDeleteDialogVisible(true);
        setDeleteDialogId(id);
    };

    const handleDeleteDialogClose = () => {
        setDeleteDialogVisible(false);
        setDeleteDialogId(null);
    };

    const deleteComment = (id) => {
        setDeleteLoading(true);
        axios
            .delete(`${server}/api/listings/comments/${listingId}`, {
                data: { id: id },
                headers: request_headers["headers"],
            })
            .then(function (reposnse) {
                dispatch(actions.loadSpecificListing(listingId));
                setDeleteLoading(false);
                dispatch(
                    actions.showSnackbar(
                        "Comment deleted successfully",
                        "success"
                    )
                );
            })
            .catch(function (error) {
                setDeleteLoading(false);
                dispatch(
                    actions.showSnackbar("Failed to delete comment", "error")
                );
            })
            .then(function (reposnse) {
                handleDeleteDialogClose();
            });
    };

    let comments = null;
    if (!loading && listing.comments.length > 0) {
        comments = listing.comments.map((comment) => {
            return (
                <ViewEditComment
                    key={comment.id}
                    onDeleteClick={handleDeleteDialogOpen}
                    onSaveClick={submitComment}
                    {...comment}
                />
            );
        });
    }

    return (
        <React.Fragment>
            <Grid item xs={12}>
                {comments ? (
                    <Typography variant="body1" style={{color: "black"}} gutterBottom>
                        Comments
                    </Typography>
                ) : null}
                {comments}
                <Dialog
                    open={deleteDialogVisible}
                    onClose={() => handleDeleteDialogClose()}
                    onBackdropClick={() => setDeleteDialogVisible(false)}
                    onEscapeKeyDown={() => setDeleteDialogVisible(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {"Are you sure you want to delete this comment?"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            This will permenantly delete the comment. There is
                            no way to recover this comment later on.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            disabled={deleteLoading}
                            onClick={() => handleDeleteDialogClose(false)}
                            color="primary"
                        >
                            Cancel
                        </Button>
                        <Button
                            disabled={deleteLoading}
                            onClick={() => deleteComment(deleteDialogId)}
                            color="primary"
                            autoFocus
                        >
                            Delete
                        </Button>
                    </DialogActions>
                </Dialog>
            </Grid>
        </React.Fragment>
    );
}
